<!--
 * @Description: 各场景通用搜索内容，直接访问了$parent
 * @Date: 2021-06-23 20:12:55
-->
<template>
  <div class="search">
    <div>
      <span>
        项目参与人：
      </span>
      <el-input
        class="search-input"
        v-model="query.fullName"
        clearable
        placeholder="项目参与人"
        @change="change"
      ></el-input>
    </div>
    <div>
      <span>
        手机号：
      </span>
      <el-input
        class="search-input"
        v-model="query.phone"
        clearable
        placeholder="手机号"
        @change="change"
      ></el-input>
    </div>
    <div>
      <span>
        是否可结算：
      </span>
      <el-select
        class="search-input"
        style="width:190px"
        v-model="query.isSettlement"
        placeholder="请选择是否可结算状态"
        clearable
        @change="change"
      >
        <el-option
          v-for="option in [
            {
              label: '可结算',
              value: 1
            },
            {
              label: '不可结算',
              value: 0
            }
          ]"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        ></el-option>
      </el-select>
    </div>
    <div>
      <span>
        是否当期人员：
      </span>
      <el-select
        class="search-input"
        style="width:160px"
        v-model="query.isCurrPeriod"
        placeholder="是否当期人员"
        clearable
        @change="change"
      >
        <el-option
          v-for="option in [
            {
              label: '是',
              value: 1
            },
            {
              label: '否',
              value: 0
            }
          ]"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        ></el-option>
      </el-select>
    </div>
    <div v-if="$checkNeedUserTag($store.state.homeProject)">
      <span>
        人员标签：
      </span>
      <selectPersonLabel @change="change" :dataObj="query"></selectPersonLabel>
    </div>
    <div>
      <span>
        是否可执行项目：
      </span>
      <el-select
        class="search-input"
        style="width:160px"
        v-model="query.isExecute"
        placeholder="是否可执行项目"
        clearable
        @change="change"
      >
        <el-option
          v-for="option in [
            {
              label: '是',
              value: 1
            },
            {
              label: '否',
              value: 0
            }
          ]"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { recordStatus } from '@/config/staticData';
import selectPersonLabel from '@/page/project-personnel-inside/components/personLabel/selectPersonLabel.vue';

export default {
  name: 'TaskSunSearch',
  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      recordStatus,
      query: {
        fullName: '',
        phone: '',
        superviseStatus: 1,
        userTag: '',
        isSettlement: 1
      },
      noInitDate: false, // 是否初始化当前时间
      dateValue: '',
      options: [
        // {
        //   label: '全部',
        //   value: 0
        // },
        {
          label: '可结算',
          value: 1
        },
        {
          label: '不可结算',
          value: 2
        }
      ],
      monthrangeOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick(picker) {
              const end = new Date();
              const start = new Date(end.getFullYear(), end.getMonth());
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 5);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          }
        ],
        disabledDate(date) {
          return date >= new Date();
        }
      }
    };
  },
  components: { selectPersonLabel },
  watch: {},
  computed: {},
  methods: {
    change() {
      this.$emit('input', { ...this.value, ...this.query });
    },
    dateChange(dates) {
      this.query.finishDt = dates[0];
      this.query.finishEndDt = dates[1];
      this.query.dateRange = dates;
      this.change();
    }
  },
  created() {
    Object.assign(this.query, this.value);
    // const start = new Date();
    // const end = new Date();
    // // 通过条件初始
    // const { dateRangeStart, dateRangeEnd } = this.$route.query;
    // if (!this.noInitDate) {
    //   this.dateValue = [
    //     dateFormat(dateRangeStart || start, 'YYYY-MM'),
    //     dateFormat(dateRangeEnd || end, 'YYYY-MM')
    //   ];
    //   this.dateChange(this.dateValue);
    // }
  }
};
</script>

<style scoped lang="scss">
.search {
  display: flex;
  margin-bottom: 0;
  align-items: center;
  & > div {
    margin-bottom: 10px;
  }
}
</style>
